import React from 'react';
import { sans, mono, coral, coralSoft, useTheme } from '../../tokens';
import { AVAILABLE_PERIODS } from '../../data/investorData';
import { getPublishedSnapshot } from '../../data/investorSnapshots';

const MONTH_NAMES = {
  jan: 'Jan', feb: 'Feb', mar: 'Mar', apr: 'Apr',
  may: 'May', jun: 'Jun', jul: 'Jul', aug: 'Aug',
  sep: 'Sep', oct: 'Oct', nov: 'Nov', dec: 'Dec',
};
const MONTH_NUMS = { jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6, jul: 7, aug: 8, sep: 9, oct: 10, nov: 11, dec: 12 };

function formatPeriodLabel(period) {
  const [month, year] = period.split('-');
  return `${MONTH_NAMES[month] || month} ${year}`;
}

export default function MonthSelector({ selectedPeriod, onPeriodChange, investorOnly = false, companyId }) {
  const t = useTheme();

  // For investors: only show periods that an admin has published.
  // For admins: show all available periods.
  const periods = investorOnly
    ? AVAILABLE_PERIODS.filter(p => getPublishedSnapshot(companyId, p))
    : AVAILABLE_PERIODS;

  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
      {periods.map((period) => {
        const isActive = period === selectedPeriod;
        return (
          <button
            key={period}
            onClick={() => onPeriodChange(period)}
            style={{
              padding: '4px 12px',
              borderRadius: 20,
              border: `1px solid ${isActive ? coral : t.border}`,
              background: isActive ? coralSoft : 'transparent',
              color: isActive ? coral : t.textSecondary,
              fontFamily: mono,
              fontSize: 11,
              fontWeight: isActive ? 600 : 400,
              cursor: 'pointer',
              outline: 'none',
              transition: 'all 0.15s',
            }}
          >
            {formatPeriodLabel(period)}
          </button>
        );
      })}
    </div>
  );
}
